<template>
  <div class="section-title">{{ text }}</div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    text: {
      type: String,
      default: 'Personal Details'
    }
  }
}
</script>

<style scoped>
.section-title {
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #091540;
}
</style>
